export default {
    downtimeUrl: "https://cl.kodland.tech",
    startPage: {
      title: '<div align="center"><b>Kodland platformuna duyduğunuz güven için teşekkür ederiz!</div></b>',
      subtitle: '<div align="center">Kısa soruları yanıtlayın ve çocuğunuz için ÜCRETSİZ dersler alın</div>',
      image: {
        url:  "/welcome/quiz_turkey_b2b_aguniversity_pk.png",
        style: {
          height: "100%",
          "max-height": "100vh",
        },
      },
      button: {
        text: "  Ders alın 🚀  ",
        style: {
          background: "#E4FF9C",
          color: "#18182E",
          "font-weight": "bold",
        },
      },
      imageMobile: {
        url: "/welcome/quiz_turkey_b2b_aguniversity_mobile.png",
        style: {
          width: "100%",
        },
      },
    },
    stopPage: {
      image: "/welcome/quiz_stop_page.jpg",
      title:
        "Eğitim platformumuza güvendiğiniz için teşekkür ederiz! Maalesef tabletler veya telefonlar derslerimizi almak için uygun değil. Bir dahaki sefere sizi sınıflarımızda görmekten mutluluk duyarız!",
    },
    quizRotateBySteps: {
      1: {
        question: "Çocuğunuz genellikle boş zamanlarını nasıl geçirir?",
        answers: [
          "🎮 Cep telefonu ve bilgisayarda oyun oynar",
          "🎨 Sanatsal faaliyetlerde bulunur: çizim, müzik, oyunculuk",
          "⚽️ Spor yapar",
          "🏕️ Ailesiyle vakit geçirir",
          "👀 Çizgi film izler",
          "🤝 Arkadaşlarıyla sosyalleşir",
        ],
      },
      2: {
        title: "Deneme dersi için hangi saatte uygunsunuz?",
        type: "timeslot",
        subtitle:
          "Özel dersinizi rezerve etmek için birkaç adım kaldı! Sizinle tanışmak için sabırsızlanıyoruz🥳",
        button: "Rezervasyon için tıklayın 🎁",
      },
      3: {
        question: "Çocuğunuzun herhangi bir bilgisayar becerisi var mı?",
        answers: [
          "😌 Evet, Microsoft Word/PowerPoint",
          "🖥 Evet, temel kodlama",
          "👍 Evet, oyun oynamayı sever (Roblox, Minecraft)",
          "🤔 Hayır",
        ],
      },
      4: {
        question: "Çalışabileceğiniz bir masaüstü/dizüstü bilgisayarınız var mı?",
        answers: [
          {
            answer: "💻 Evet",
            distribution_tag_question: [13,18],
          },
          {
            answer: "😐 Hayır",
            stopAnswer: true,
          },
        ],
      },
      5: {
        title: "Çocuğunuz kaç yaşında?",
        type: "age",
        subtitle: "Çocuğunuzun yaşına göre en eğlenceli kursu seçeceğiz",
        button: "İleri 🚀",
      },
      6: {
        title: "Çocuğunuzun adı nedir?",
        type: "child_name",
        subtitle: "Veriler korunmaktadır ve talebiniz üzerine silinecektir 🚨",
        button: "İleri 🚀",
      },
      7: {
        title: "E-postanızı girin",
        type: "mail",
        subtitle: "Endişelenmeyin, spam gönderilmeyecek😅",
        button: "İleri 🚀",
      },
      8: {
        title: "Telefon numaranızı girin",
        type: "phone",
        subtitle: "Önemli konularda sizinle iletişime geçmek için kullanacağız 📞",
        button: "Neredeyse bitti 🔥",
      },
      9: {
        title: "İsminizi girin",
        type: "parent_name",
        subtitle: "Bizim adımız Kodland, sizinki ne?👋",
        button: "Son adım! 🎉",
      },
    },
  };
  